/**
 * Definition for View Artist List
 * @module views/ViewArtistList
 */
import * as THREE from 'three';
import { createTextLabel, randMinMax } from '../util';
import { itemFaceCameraY } from './Behaviours';

export default {

    /**
     * URI used in URL
     * @type String
     */
    path: '/artist-list/',
    /**
     * is this views cameraIndex limited 0-1?
     * @type boolean
     */
    isFinite: true,
    /**
     * the desiredCameraIndex on view load
     * @type float
     */
    startCameraNormal: 1,
    /**
     * @type function
     */
    willMount() {
    },
    /**
     * @param items {Array} Array of Items
     */
    willUnmount(items) {
        
        items.forEach((item, i) => {
            for (var k = item.element.children.length-1; k>=0; k--) {
                item.element.remove(item.element.children[k]);
            }
        });
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param items {Array} Array of Items
     */
    update(cam, items) {
        items.forEach((item, i) => itemFaceCameraY.call(item));

        if(cam.cameraWrap.rotation.y < -Math.PI/4) {
            cam.cameraWrap.rotation.y = -Math.PI/4;
        } else if(cam.cameraWrap.rotation.y > Math.PI/4) {
            cam.cameraWrap.rotation.y = Math.PI/4;
        }
    },

    /**
     * @param cam {Cam} The Camera Wrapper
     * @param isInitial {boolean} true if items should be placed instantly
     */
    arrangeItems(items, isInitial) {

        const artistCounter = [{ 
                artist: 'Verschiedene', 
                items: []
            }];

        //count items per artist
        items.forEach((item, i) => {

            const existingArtist = artistCounter.findIndex(elem => elem.artist === item.props.actorInRole);
            if(existingArtist === -1) {
                artistCounter.push({
                    artist: item.props.actorInRole,
                    items: [item]
                });
            } else {
                artistCounter[existingArtist].items.push(item);
            }
        });

        //resort artists with few items into one
        let i=1;
        while(i < artistCounter.length) {

            if( artistCounter[i].items.length < 3 ) {
                artistCounter[0].items.push(...artistCounter[i].items);
                artistCounter.splice(i, 1);
            } else {
                i++;
            }
        }

        //sort artists by item count
        artistCounter.sort((a, b) => {
            return b.items.length - a.items.length;
        })

        //hotfix: switch Franz Marc and "Verschiedene"
        const tmp = artistCounter[0];
        artistCounter[0] = artistCounter[1];
        artistCounter[1] = tmp;

        let artistYOffset = 0;
        for(let k=0; k<artistCounter.length; k++) {

            let totalRuns = 0;
            let itemRuns = 0;
            const confirmed = [];

            while(confirmed.length < artistCounter[k].items.length) {

                const index = confirmed.length;
                const item = artistCounter[k].items[index];
                const randomPos = new THREE.Vector3();

                randomPos.x = randMinMax(-itemRuns/2, itemRuns/2);
                randomPos.y = artistYOffset + randMinMax(-itemRuns/8, itemRuns/8);
                randomPos.z = -2 + (Math.abs(randomPos.x)/10);

                let overlapping = false;
                for(let i=0; i<confirmed.length; i++) {

                    let minDist = confirmed[i].element.geometry.boundingSphere.radius;
                    minDist += item.element.geometry.boundingSphere.radius;

                    const dist = randomPos.distanceTo(confirmed[i].desiredPosition);

                    if(dist < minDist) {
                        overlapping = true;
                        break;
                    }
                }

                //place item
                if(!overlapping) {

                    //add artist name label to first item
                    if(confirmed.length === 0) {
                        let text = artistCounter[k].artist;
                        if(text.indexOf(',') > -1) {
                            const tmp = text.split(', ');
                            text = tmp[1] + ' ' + tmp[0];
                        }
                        const label = createTextLabel(text.toUpperCase(), 8, 1, true);

                        const lx = -1;
                        const ly = 1 + Math.floor(artistCounter[k].items.length/40);
                        const lz = 0.5;

                        label.position.set(lx, ly, lz);
                        item.element.add(label);
                    }

                    item.desiredPosition = randomPos;
                    confirmed.push(item);
                    itemRuns = 0;

                    if(isInitial) {
                        item.currentPosition = item.desiredPosition;
                    }

                    //console.log('placed item', confirmed.length, 'of', items.length, 'in run #', runs);
                }

                itemRuns++;
                totalRuns++;
                if(totalRuns > items.length*items.length) {
                    console.log('canceled brute force');
                    break;
                }
            }

            artistYOffset -= 8; //default offset
            
            //hotfix: more space for first artists
            if(k < 2) {
                artistYOffset -= 8;
            } else if(k < 4) {
                artistYOffset -= 2;
            }

            //console.log('finished brute force layout for', artistCounter[k].artist, 'in', totalRuns, 'runs');
        }
    },

    /**
     * @param i {float} currentCameraIndex
     * @param cameraWrap {Object} [THREE.js CameraWrap]
     * @param camera {Object} [THREE.js Camera]
     */
    lerpCamera(i, cameraWrap, camera) {

        cameraWrap.position.x = 0;
        cameraWrap.position.y = (1-i)*-100;
        cameraWrap.position.z = 8;//-(i*3);
        //console.log(i, cameraWrap.position);
        return cameraWrap.position;
    }
}